import TableCell from "../common/table/tableCell"
import TableCellInformation from "../common/table/tableCellInformation"
import TableCellTag from "../common/table/tableCellTag"
import TableCellDate from "../common/table/tableCellDate"
import TableCellTime from "../common/table/tableCellTime"
import ButtonIcon from "../common/buttonIcon"
import { useState } from "react"
import AlertMessageModal from "../alertMessageModal"
import { t } from "i18next";
import { useAppDispatch } from "../../redux"
import { deletePrenotationStore } from "../../redux/reducer/prenotationReducer"
import DropdownIcon from "../common/dropdownIcon"
import { HttpService } from "../../services/HttpService"
import { useSelector } from "react-redux"

const PrenotationRow = (props: any) => {
  let prenotation = ((props.prenotation && props.prenotation.length) ? props.prenotation : []);
  const [modalDelete, setmodalDelete] = useState(false);
  const [selectPrenotation, setselectPrenotation] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [errorMessageModal, setErrorMessageModal] = useState("");
  const [attendanceSendInvitation, setAttendanceSendInvitation] = useState("");
  const [spinnerAttendanceSendInvitation, setSpinnerAttendanceSendInvitation] = useState(false);
  const { eventId } = useSelector((state: any) => state.login);

  const dispatch = useAppDispatch();
  const deletePrenotation = (id: any, bookingId: string) => {
    setmodalDelete(true);
    setselectPrenotation(id);
    setBookingId(bookingId);
  }
  const deletePrenotationInStore = async () => {
    try {
      setmodalDelete(false);
      const result: any = await dispatch(deletePrenotationStore(selectPrenotation));
      if (result && result.response && result.response.status > 400) {
        setErrorMessageModal(result.response.data.result.message)
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  const getPrenotationInfo = () => {
    let prenotationInfo = { bookingId: "", name: "", surname: "" };
    if (selectPrenotation) {
      var prenotationSelect = prenotation.find((p: any) => p._id === selectPrenotation);
      prenotationInfo.bookingId = prenotationSelect?.bookingId;
      prenotationInfo.name = prenotationSelect?.guest.name;
      prenotationInfo.surname = prenotationSelect?.guest.surname;
    }
    return prenotationInfo
  }
  const sendInvitation = async (attendanceId: string) => {
    setSpinnerAttendanceSendInvitation(true);
    const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/resendInvitation/${attendanceId}`, {})
    setSpinnerAttendanceSendInvitation(false)
    setAttendanceSendInvitation("");
  }

  const openNoteBooking = (booking: string, attendanceFullName: string) => {
    if (typeof props.openPopUpNote === 'function') {
      props.openPopUpNote(booking, attendanceFullName);
    }
  }

  return (
    <>
      <tbody>
        {
          prenotation.map((value: any, key: number) => (
            <tr key={key}>
              <TableCell label={'#' + value?.bookingId} />
              <TableCellInformation name={value.guest.name} />
              <TableCell label={value.guest.surname} />
              <TableCell label={value.guest.email} />
              <TableCellDate data={value.timeslotyYearMonthDay} />
              <TableCellTime dataStart={value.timeslot?.startDate} dataEnd={value.timeslot?.endDate} />
              <TableCellTag label={value.timeslotcategories?.name} color={value.timeslotcategories?.color} />
              {((value?.createdById) ?
                <TableCellTag label="Farmacista" color="#9ea2a4" />
                :
                <TableCellTag label="Cittadino" color="#5FB5EB" />
              )}

              <td className="text-right">
                <>
                  <ButtonIcon icon="sticky_note_2" handleClick={() => { openNoteBooking(value?.bookingId, `${value.guest.name} ${value.guest.surname}`) }} />
                  <ButtonIcon icon="visibility" handleClick={() => { props?.openPopUpViewPrenotationByTimeslot(value?.bookingId, value?.timeslot) }} />
                  <ButtonIcon icon="delete" handleClick={() => { deletePrenotation(value?._id, value?.bookingId) }} />
                  <DropdownIcon dropdownItems={[{ title: t('sendReservation'), callback: () => { setAttendanceSendInvitation(value._id); setSpinnerAttendanceSendInvitation(false) } }]} icon="more_vert" />
                </>
              </td>
            </tr>
          ))
        }
      </tbody >
      <AlertMessageModal
        title={t('delete')}
        description={t('prenotation.label-delete', getPrenotationInfo())}
        closeModal={() => { setmodalDelete(false) }}
        titleButtonPrimary={t('delete')}
        handleClosePrimary={() => { deletePrenotationInStore(); }}
        titleButtonSecondary={t('cancel')}
        handleCloseSecondary={() => { setmodalDelete(false); }}
        show={modalDelete} />
      <AlertMessageModal
        show={(errorMessageModal !== "")}
        title={t('attention')}
        closeModal={() => (setErrorMessageModal(""))}
        description={errorMessageModal}
      />
      <AlertMessageModal
        title={t('attention')}
        description={t('popup-send-reservation.message')}
        closeModal={() => (setAttendanceSendInvitation(""))}
        titleButtonPrimary={t('popup-send-reservation.button-yes')}
        handleClosePrimary={() => { sendInvitation(attendanceSendInvitation); }}
        titleButtonSecondary={t('popup-send-reservation.button-no')}
        handleCloseSecondary={() => (setAttendanceSendInvitation(""))}
        spinnerButtonSecondary={spinnerAttendanceSendInvitation}
        show={(attendanceSendInvitation != "")} />
    </>
  )
}

export default PrenotationRow